import { ReactElement, useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import { useModifiedTranslation } from "../../hooks/useModifiedTranslation";

/*
 * ログアウト確認モーダル。「はい」で画面を再読み込みしてログイン状態を捨てる
 */
export function LogoutConfirmDialog(
  props: Readonly<{ isOpen: boolean; onClose: () => void }>,
): ReactElement {
  const { isOpen, onClose } = props;
  const t = useModifiedTranslation();
  const cancelRef = useRef(null);

  return (
    <AlertDialog
      isCentered
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent backgroundColor="common.base">
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t("Home.logout")}
          </AlertDialogHeader>

          <AlertDialogBody
            my={12}
            fontSize="lg"
            textAlign="center"
            fontWeight="normal"
          >
            {t("Home.logoutConfirm")}
          </AlertDialogBody>

          <AlertDialogFooter justifyContent="space-between">
            <Button
              variant="ghost"
              ref={cancelRef}
              onClick={onClose}
              data-testid="logout-cancel"
            >
              {t("Modal.cancel")}
            </Button>
            <Button
              variant="ghost"
              onClick={() => window.location.reload()}
              data-testid="logout-confirm"
            >
              {t("Modal.yes")}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
